export default __webpack_public_path__ + "static/media/1000_2 1.c212039b.svg";